import * as React from 'react'
import {Box} from "@mui/material";
import { translateCountryName } from "@ui-seeker/utils"

import {LabelCountry, NotAllowedBlock, RetailerBlock} from "@components";


export default function retailerColumn() {
    return [ {
        name: 'retailer',
        label: 'Retailer',
        options: {
            display: 'excluded',
            customBodyRowRender: v => !!v ? v : 'No site available',
        }
    }, {
        name: 'retailer', label: 'Retailer',
        options: {
            filter: false,
            customBodyRowRenderLite: (value, { country, siteURL, pageURL }) => <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                {
                    !!value ?
                        <RetailerBlock
                            retailer={value}
                            country={country}
                            siteURL={siteURL}
                            pageURL={pageURL}
                        /> :
                        <NotAllowedBlock />
                }
            </Box>
        }
    }]
}